/* Corlanza — comportamientos de las secciones del embudo.
   Cada seccion emite su propia etiqueta <script>, asi que este archivo puede
   ejecutarse varias veces por pagina: todo lo de abajo es idempotente. */
(function(){
  'use strict';
  if (window.__corlanzaBooted) return;
  window.__corlanzaBooted = true;

  function once(el, key){
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* Copys que se encienden al entrar en pantalla */
  function initFeats(root){
    var feats=[].slice.call(root.querySelectorAll('.feat')).filter(function(f){ return once(f,'corFeat'); });
    if(!feats.length) return;
    if(!('IntersectionObserver' in window)){ feats.forEach(function(f){f.classList.add('lit');}); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var i=feats.indexOf(e.target);
          setTimeout(function(){ e.target.classList.add('lit'); }, Math.max(0,i)*130);
          io.unobserve(e.target);
        }
      });
    },{threshold:0.4});
    feats.forEach(function(f){ io.observe(f); });
    setTimeout(function(){ feats.forEach(function(f){ f.classList.add('lit'); }); }, 1600);
  }

  /* Acordeon: hover en escritorio, toque en movil. Uno abierto a la vez. */
  function initAcc(root){
    [].slice.call(root.querySelectorAll('.acc-list')).forEach(function(list){
      if(!once(list,'corAcc')) return;
      var canHover=!!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);
      var items=[].slice.call(list.querySelectorAll('.acc'));
      function openOnly(item){
        items.forEach(function(o){
          var on=(o===item);
          o.classList.toggle('open',on);
          var h=o.querySelector('.acc-head');
          if(h) h.setAttribute('aria-expanded',on?'true':'false');
        });
      }
      items.forEach(function(item){
        var head=item.querySelector('.acc-head'), timer=null;
        if(!head) return;
        if(canHover){
          item.addEventListener('mouseenter',function(){ clearTimeout(timer); timer=setTimeout(function(){ openOnly(item); },30); });
          item.addEventListener('mouseleave',function(){ clearTimeout(timer); });
          head.addEventListener('click',function(){ clearTimeout(timer); openOnly(item); });
        } else {
          head.addEventListener('click',function(){
            if(item.classList.contains('open')){ item.classList.remove('open'); head.setAttribute('aria-expanded','false'); }
            else { openOnly(item); }
          });
        }
      });
    });
  }

  /* Marquesina de resenas: clona las tarjetas para un bucle continuo */
  function initRevTrack(root){
    if(window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    [].slice.call(root.querySelectorAll('.rev-track')).forEach(function(track){
      if(!once(track,'corCloned')) return;
      [].slice.call(track.children).forEach(function(c){
        var clon=c.cloneNode(true);
        clon.setAttribute('aria-hidden','true');
        track.appendChild(clon);
      });
    });
  }

  /* Selector de cantidad */
  function initQty(root){
    [].slice.call(root.querySelectorAll('.qty')).forEach(function(box){
      if(!once(box,'corQty')) return;
      var input=box.querySelector('input');
      if(!input) return;
      function clamp(){
        var min=parseInt(input.min||'1',10), max=parseInt(input.max||'99',10);
        var v=parseInt(input.value||'1',10); if(isNaN(v)) v=min;
        input.value=Math.max(min,Math.min(max,v));
      }
      box.addEventListener('click',function(e){
        var b=e.target.closest('button');
        if(!b || !box.contains(b)) return;
        e.preventDefault();
        input.value=(parseInt(input.value||'1',10)||1)+(b.dataset.step==='up'?1:-1);
        clamp();
      });
      input.addEventListener('change',clamp);
    });
  }

  /* Galeria de producto */
  function initGal(root){
    [].slice.call(root.querySelectorAll('[data-gal]')).forEach(function(gal){
      if(!once(gal,'corGal')) return;
      var main=gal.querySelector('.gal-main img');
      var thumbs=[].slice.call(gal.querySelectorAll('.gal-thumbs button'));
      if(!main||!thumbs.length) return;
      thumbs.forEach(function(t){
        t.addEventListener('click',function(){
          if(!t.dataset.full) return;
          main.removeAttribute('srcset');
          main.src=t.dataset.full;
          main.alt=t.dataset.alt||main.alt;
          thumbs.forEach(function(o){ o.classList.toggle('on', o===t); });
        });
      });
    });
  }

  /* Video vertical: se reproduce al pulsar */
  function initVideo(root){
    [].slice.call(root.querySelectorAll('.vid-frame')).forEach(function(frame){
      if(!once(frame,'corVid')) return;
      var v=frame.querySelector('video'), b=frame.querySelector('.vid-play');
      if(!v||!b) return;
      b.addEventListener('click',function(){
        frame.classList.add('playing');
        v.controls=true;
        var pr=v.play();
        if(pr && pr.catch) pr.catch(function(){ frame.classList.remove('playing'); });
      });
    });
  }

  function boot(root){
    root = root || document;
    initFeats(root); initAcc(root); initRevTrack(root); initQty(root); initGal(root); initVideo(root);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();});
  else boot();

  /* El editor de temas recarga secciones sueltas */
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
